import sections from '../../utils/theme-sections';
import openModal from '../../components/INF-Modal/openModal';
import { Gallery } from '../../components/Gallery';

export default async (
  product_url,
  init_count,
  list_name,
  cart_edit_item_enabled = false,
  previous_variant_id = null,
  previous_variant_quantity = null,
  product_data = null,
) => {
  const modal = document.getElementById('QuickView');
  const quickViewContent = document.querySelector('[data-quick-view-content]');

  modal.classList.add('QuickView--loading');

  // Only empty the modal immediately if it's not already open
  if (!modal.classList.contains('Modal--open')) {
    quickViewContent.innerHTML = '';
  }

  openModal(modal);
  // Parse product data if it exists
  let product_data_formatted = null;
  if (product_data) {
    product_data_formatted = JSON.parse(product_data);
  }
  // Check if user is in US - if not, use fetch method instead of FastSimon
  const isUS = window.theme?.country_iso === 'US';

  if (product_data_formatted !== null) {
    const videoProduct = product_data_formatted.att.find((att) => att[0].includes('custom.original_video_source'));
    if (isUS && !product_data_formatted?.v?.includes('GIVEX') && !videoProduct) {
      try {
        buildQuickViewViaFetch(
          product_url,
          init_count,
          list_name,
          cart_edit_item_enabled,
          previous_variant_id,
          previous_variant_quantity,
          quickViewContent,
          modal,
        );
        return; // Don't proceed to fetch path if FastSimon succeeded
      } catch (err) {
        console.warn('FastSimon QuickView error, falling back to fetch method:', err);
        // Continue to fetch path below
      }
    }
  }

  // Build via fetch (original method) or as fallback
  buildQuickViewViaFetch(
    product_url,
    init_count,
    list_name,
    cart_edit_item_enabled,
    previous_variant_id,
    previous_variant_quantity,
    quickViewContent,
    modal,
  );
};

// Extracted original fetch-based QuickView builder (allows fallback if FastSimon fails)
function buildQuickViewViaFetch(
  product_url,
  init_count,
  list_name,
  cart_edit_item_enabled,
  previous_variant_id,
  previous_variant_quantity,
  quickViewContent,
  modal,
) {
  try {
    let new_url = product_url.split('#')[0];
    const ajax_url = product_url.includes('?') ? `${new_url}&view=ajax` : `${new_url}?view=ajax`;

    fetch(ajax_url)
      .then((response) => response.text())
      .then((response) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = response;

        if (cart_edit_item_enabled) {
          const cartEditHeading = document.createElement('h1');
          cartEditHeading.classList.add('CartEditItem__title');
          cartEditHeading.textContent = 'Edit Your Item';
          tempDiv
            .querySelector('[data-quick-view-container]')
            .insertBefore(cartEditHeading, tempDiv.querySelector('#shopify-section-quickview-gallery'));

          const promoMessage = tempDiv.querySelector('.ProductHeading__promo_message');
          const discountLabel = tempDiv.querySelector('.ProductHeading__discount');
          if (promoMessage && discountLabel) {
            discountLabel.innerHTML = promoMessage.innerHTML;
          }

          const addToBagButtonPod = tempDiv.querySelector('.ProductInfo__add-to-cart');
          const addToBagButton = tempDiv.querySelector('.ProductInfo__add-to-cart>button');
          if (addToBagButton) {
            addToBagButton.setAttribute('data-edit-cart-item', 'true');
            addToBagButton.name = 'edit';
            addToBagButton.title = 'Edit Cart Item';
            addToBagButton.removeAttribute('data-add-to-cart');
            addToBagButton.innerHTML = '<span data-edit-cart-item-text>Update Now</span>';
            if (addToBagButton.disabled) {
              addToBagButtonPod?.setAttribute('data-edit-cart-item', false);
              addToBagButton.setAttribute('data-edit-cart-item', false);
              addToBagButton.innerHTML = '<span data-edit-cart-item-text>Sold Out</span>';
            }
          }

          const formAddToBag = tempDiv.querySelector('.ProductInfo__form');
          if (formAddToBag) {
            const inputPreviousVariantId = document.createElement('input');
            const inputPreviousVariantQuantity = document.createElement('input');
            formAddToBag.setAttribute('data-edit-cart-item', 'true');
            inputPreviousVariantId.type = 'hidden';
            inputPreviousVariantId.setAttribute('name', 'previous-variant-id');
            inputPreviousVariantId.setAttribute('value', previous_variant_id);
            formAddToBag.appendChild(inputPreviousVariantId);
            inputPreviousVariantQuantity.type = 'hidden';
            inputPreviousVariantQuantity.setAttribute('name', 'previous-variant-quantity');
            inputPreviousVariantQuantity.setAttribute('value', previous_variant_quantity);
            formAddToBag.appendChild(inputPreviousVariantQuantity);
          }

          const viewDetailsLink = tempDiv.querySelector('.ProductInfo__view-details');
          if (viewDetailsLink) viewDetailsLink.innerHTML = 'View Full Details';
        }

        const product = tempDiv.querySelector('[data-quick-view-container]');
        const productJson = tempDiv.querySelector('[data-product-json]');
        if (!product) throw new Error('QuickView fetch: product container not found');

        product.querySelectorAll('.Animate, .AnimateOnLoad').forEach((el) => {
          el.className = el.className.replace(/(^|\s)Animate--\S+/g, '');
          el.classList.add('Animate--fade-in');
        });

        const productTitle = product.querySelector('.ProductHeading__title');
        if (productTitle) {
          const titleText = productTitle.textContent;
          productTitle.innerHTML = `<a href="${product_url}" data-quickview-ignore>${titleText}</a>`;
        }

        const hasBreadcrumbLink = tempDiv.querySelector('.Breadcrumb__link>a:last-child');
        if (hasBreadcrumbLink) {
          product.setAttribute('data-collection', hasBreadcrumbLink.textContent);
        } else {
          product.setAttribute('data-collection', list_name);
        }
        window.theme.quickViewCollection = hasBreadcrumbLink ? hasBreadcrumbLink.textContent : list_name;

        quickViewContent.innerHTML = '';
        quickViewContent.appendChild(product);
        if (productJson && !product.contains(productJson)) {
          quickViewContent.appendChild(productJson);
        }
        modal.setAttribute('data-built-with-fastsimon', 'false');

        try {
          if (
            window.location.pathname !== '/cart' &&
            window.yotpo &&
            typeof window.yotpo.refreshWidgets === 'function'
          ) {
            window.yotpo.refreshWidgets();
          }
        } catch (error) {
          console.log('Quickview: Error in yotpo refresh', error);
        }

        sections
          .getInstances('product')
          .then((instances) => {
            instances.forEach((instance) => instance.trigger('section_load'));
          })
          .catch((err) => console.error('Quickview error:', err));

        if (window.theme?.breakpoints?.current === 'mobile') {
          const viewDetailsMobile = document.querySelector('.ProductInfo__view-details');
          if (viewDetailsMobile) {
            viewDetailsMobile.innerText = 'View Full Product Details';
            if (cart_edit_item_enabled) viewDetailsMobile.innerText = 'View Full Details';
          }
        }

        document.dispatchEvent(new Event('shouldProcessProductData'));

        const galleryEl = quickViewContent.querySelector('#quickview-gallery');
        if (galleryEl) {
          const galleryInstance = new Gallery({
            gallery: galleryEl,
            prefixClassName: 'pdp-c-gallery',
            features: { keydown: false, zoom: false },
          });
          galleryInstance.setObservers();
          setTimeout(() => {
            galleryInstance.init();
            if (cart_edit_item_enabled && galleryInstance.carousel) {
              galleryInstance.carousel.scrollTo({ left: 0 });
            }
          }, 0);
        }

        document.addEventListener('DOMContentLoaded', () => {
          const selectedVariant = document.querySelector(
            '[data-product-info-container] .ProductOption__variant--selected',
          );
          if (selectedVariant) selectedVariant.click();
        });

        modal.classList.remove('QuickView--loading');
        openModal(modal);

        const handleQuickViewCloseFetch = (e) => {
          if (e.detail && e.detail.id === 'QuickView') {
            try {
              if (window.dataLayer) {
                const productTitleText =
                  product.querySelector('.ProductHeading__title')?.textContent?.trim() || 'Unknown Product';
                const productIdFromUrl = product_url.split('/products/')[1]?.split('?')[0] || 'unknown';
                window.dataLayer.push({
                  event: 'quick_view_closed',
                  product_name: productTitleText,
                  product_id: productIdFromUrl,
                  product_url: product_url,
                  ...(list_name && { list_name: list_name }),
                });
              }
            } catch (error) {
              console.warn('QuickView close GTM tracking error (fetch path):', error);
            }
            document.removeEventListener('modalDidClose', handleQuickViewCloseFetch);
          }
        };
        document.addEventListener('modalDidClose', handleQuickViewCloseFetch);

        try {
          if (window.dataLayer) {
            const productTitleText =
              product.querySelector('.ProductHeading__title')?.textContent?.trim() || 'Unknown Product';
            const productIdFromUrl = product_url.split('/products/')[1]?.split('?')[0] || 'unknown';
            window.dataLayer.push({
              event: 'quick_view_opened',
              product_name: productTitleText,
              product_id: productIdFromUrl,
              product_url: product_url,
              ...(list_name && { list_name: list_name }),
            });
          }
        } catch (error) {
          console.warn('QuickView GTM tracking error (fetch path):', error);
        }

        const finalSaleElement = product.querySelector('.ProductInfo__clearance[data-show-for-clearance]');
        if (finalSaleElement) {
          const priceElement = product.querySelector('[data-product-price] span[role="text"]');
          if (priceElement) {
            const priceText = priceElement.textContent;
            const priceMatch = priceText.match(/\$?(\d+\.\d{2})/);
            finalSaleElement.style.display = priceMatch && priceMatch[1].endsWith('.97') ? 'block' : 'none';
          }
        }
      })
      .catch((error) => {
        console.error('Error fetching the AJAX URL:', error);
      });
  } catch (err) {
    console.warn('QuickView fetch builder encountered an error:', err);
  }
}
